<nz-pagination
  [nzPageIndex]="configuration?.pager?.page"
  [nzTotal]="configuration?.totalItemCount"
  (nzPageIndexChange)="onNzPageIndexChange($event)"
  [nzSize]="configuration?.nzSize || 'default'"
  [nzShowSizeChanger]="
    (configuration?.nzShowSizeChanger &&
      configuration?.totalItemCount > configuration?.pager?.perPage) ||
    false
  "
  [nzPageSizeOptions]="configuration?.nzPageSizeOptions"
  (nzPageSizeChange)="onNzpageSizeChanged($event)"
></nz-pagination>